import React from "react"
import PropTypes from 'prop-types'

import SelectGenericNew from "../../../../../gd-ui/select-generic-new/select-generic-new";
import {
    VALIDATION_CHECKED,
    VALIDATION_LABELS, VALIDATION_UNCHECKED
} from "../../../../../model2/automation/lib/custom-field-validation"
import {FieldAutomationTriggerFormProps} from "../../../../render/automation-trigger-form";

const options = _.map([
    VALIDATION_CHECKED,
    VALIDATION_UNCHECKED,
], value=>({
    value: value,
    label: _.get(VALIDATION_LABELS,value)
}))

const debug = false
// const debug = "CheckboxTriggerForm"

export default class FieldCheckbox_AutomationTriggerForm extends React.Component<FieldAutomationTriggerFormProps, any> {

    static propTypes = {
        config          : PropTypes.object,

        onChangeCallback: PropTypes.func,
    }

    constructor(props:FieldAutomationTriggerFormProps) {
        super(props)

        this.state = {
            validationType  : _.get(props.config, 'validationType', VALIDATION_CHECKED),
        }
    }

    onChangeValidationType = (option:any) => {
        const validationType = option.value

        this.setState({
            validationType
        }, ()=>{
            this.props.onChangeCallback({validationType})
        })
    }

    render() {
        debug && console.log(debug, 'render', this.state, options)

        return (
            <div className="flex-row-left-top">
                <div className="label w-100">Trigger when</div>
                <SelectGenericNew className                     = "selector w-180"
                                  options                       = {options}
                                  value                         = {this.state.validationType}
                                  popoverScrollContainerClasses = "max-h-200 max-w-300"
                                  disabled                      = {this.props.config.disabled}
                                  onChange                      = {this.onChangeValidationType}/>
            </div>
        )
    }
}
